import React from 'react'
import { FaLocationDot } from 'react-icons/fa6' 
import useAppContext from '../../hook/useAppContext'
import FriendsMobile from '../friendsmobile/FriendsMobile'
import './infodata.css'

const InfoData = () => {

      const {user, data} = useAppContext()
      const {personal, images, posts, friends} = user

      const photo_amount = images.code ? "0" : images.length 
      const post_amount = posts.code ? "0" : posts.length 
      const friend_amount = friends.code ? "0" : friends.length 
      const username = personal.code || personal.name.length === 0 ? data.info.name : personal.name
      const homepage = personal.code || personal.homepage.length === 0 ?  data.info.homepage.replace("https://", "") : personal.homepage.replace("https://", "")
      const location = personal.code || personal.location.length === 0 ? data.info.location : personal.location 
      const flag = personal.code || personal.country_flag.length === 0 ? false : personal.country_flag

      return (
            <div className="infordata_content">
                  <div className="infodata_group grid col-3">
                        <div className="infodata_col data flex">
                              <div className="infodata_col__count flex">
                                    <strong>{photo_amount}</strong>
                                    <span>Photos</span>
                              </div>
                              <div className="infodata_col__count flex">
                                    <strong>{post_amount}</strong>
                                    <span>Posts</span>
                              </div>
                              <div className="infodata_col__count flex">
                                    <strong>{friend_amount}</strong>
                                    <span>Friends</span>
                              </div>
                        </div>
                        <div className="infodata_col data_user flex">
                              <h1>{username}</h1>
                              <p>{homepage}</p>
                        </div>
                        <div className="infodata_col data_location flex">
                              <div className="location_icon flex">
                                    <span><FaLocationDot /></span>
                              </div>
                              <div className="location_data__info">
                                    {
                                          flag ? <img width="40" src={flag} alt={location} /> : ""
                                    }
                                    <p>{location}</p>
                              </div>
                        </div>
                  </div>
                  <div className="friends_mobile">
                        <FriendsMobile friends={friends}/>
                  </div>
            </div>
            
      )
}

export default InfoData
